import React from 'react';
import useTheme from '@hero/branding/theme';
import Form, { useFormContext } from '@hero/ui-kit/inputs/Form';
import Radio from '@hero/ui-kit/inputs/Radio';
import RadioGroup from '@hero/ui-kit/inputs/RadioGroup';
import H from '@hero/ui-kit/typography/H';
import Section from '@hero/ui-kit/layout/Section';
import Button from '@hero/ui-kit/inputs/Button';
import planOffersSchema from '../../../../../views/CancellationFlow/validator/planOffersSchema';
import { PlanOffer } from '../../../../Membership/api/useGetRTMTransferOptions';
import { useTransferToD2C } from '../context/TransferToD2CContext';
import InlineLoader from '../../../../../components/InlineLoader';

const getPlanLabel = (plan: PlanOffer) => {
    const monthlyPrice = `$${(plan.monthly_fee / 100).toFixed(2)}`;
    const commitment =
        plan.commitment_months > 0 ? `${plan.commitment_months}-month commitment` : 'No commitment';
    return `${plan.name} - ${monthlyPrice}/month (${commitment})`;
};

const FormElements: React.FC = () => {
    const { rtmPlanOffers, goBackToMitigationOffers } = useTransferToD2C();
    const { borders, colors } = useTheme();
    const {
        formState: { isValid }
    } = useFormContext();

    const radioStyle: React.CSSProperties = {
        padding: '1rem'
    };

    const border: React.CSSProperties = {
        ...borders.bottom,
        ...borders.variant.secondary,
        borderWidth: 2,
        borderColor: colors.neutrals.borderAlpha
    };

    return (
        <>
            <H role="h6">Regular plans:</H>

            {rtmPlanOffers ? (
                <RadioGroup
                    name="plan_offers"
                    displayName=""
                    noBorders
                    styles={{ marginBottom: '0' }}
                >
                    {rtmPlanOffers.map((plan) => (
                        <Radio
                            key={plan.storefront_key}
                            id={plan.storefront_key}
                            value={plan.storefront_key}
                            labelText={getPlanLabel(plan)}
                            styles={{ ...radioStyle, ...border }}
                        />
                    ))}
                </RadioGroup>
            ) : null}

            <Section centered>
                <Button type="submit" width="large" disabled={!isValid}>
                    Next
                </Button>
                <Button
                    type="button"
                    variant="secondary"
                    width="large"
                    onClick={goBackToMitigationOffers}
                >
                    Back
                </Button>
            </Section>
        </>
    );
};

const PlanSelection: React.FC = () => {
    const { handleChoosePlan, isLoadingPlans } = useTransferToD2C();

    if (isLoadingPlans) {
        return <InlineLoader />;
    }

    return (
        <Form validationSchema={planOffersSchema} submitFn={handleChoosePlan}>
            <FormElements />
        </Form>
    );
};

export default PlanSelection;
